import lessRequire from '../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

lessRequire('modules/shared/filters/item.less');

const FilterItem = ({ data, onToggle, toggleChildrenHighlight, intl }) =>
	<a
		href="#"
		className={cn({
			'filter-item': true,
			'is-open': data.isOpen,
			highlight: data.shouldHighlight
		})}
		onClick={e => {
			e.preventDefault();
			onToggle(data.id);
		}}
		onMouseEnter={() => toggleChildrenHighlight(data.id)}
		onMouseLeave={() => toggleChildrenHighlight(data.id)}
	>
		{data.appliedItemsCount > 0 ? <span className="filter-item__apply-count">{data.appliedItemsCount}</span> : ''}
		<span className="filter-item__title font-proxima-nova-semibold">{intl(data.title)}</span>
	</a>;

FilterItem.propTypes = {
	data: PropTypes.object,
	onToggle: PropTypes.func,
	toggleChildrenHighlight: PropTypes.func,
	intl: PropTypes.func
};

export default FilterItem;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/filters/item.js